import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Breadcrumb,
  Modal,
  Form,
  FormGroup,
  FormControl,
  Col
}from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'
import StatesDropdown from '../statesdropdown'

@observer(['organizations', 'globals'])
export default class Organizations extends Component {

  constructor(props) {
    super(props)

    this.props.organizations.loadAllOrganizations()

    this.state = {
      showEditOrgModal: false,
      editId: 0,
      editName: 'Loading...',
      editAddress: 'Loading...',
      editCity: 'Loading...',
      editState: 'Loading...',
      editZipCode: 'Loading...',
      editEmail: 'Loading...',
      editPhone: 'Loading...',
      editUrl: 'Loading...'
    }

    if (this.props.params.organizationId) {
      this.props.organizations.loadOrganization(this.props.params.organizationId, (org) => {
        this.openEditOrgModal(org)
      })
    }
  }

  openEditOrgModal(row) {
    this.setState({
      showEditOrgModal: true
    })

    this.setState({
      editId: row.id,
      editName: row.name,
      editAddress: row.address,
      editCity: row.city,
      editState: row.state,
      editZipCode: row.zipCode,
      editEmail: row.email,
      editPhone: row.phone,
      editUrl: row.url
    })

    /*
    this.props.organizations.loadOrganization(cell, (data) => {
      this.setState({
        editId: data.id,
        editName: data.name,
        editAddress: data.address,
        editCity: data.city,
        editState: data.state,
        editZipCode: data.zipCode,
        editEmail: data.email,
        editPhone: data.phone,
        editUrl: data.url
      })
    })
    */
  }

  closeEditOrgModal() {
    this.setState({
      showEditOrgModal: false,
      editId: 0,
      editName: 'Loading...',
      editAddress: 'Loading...',
      editCity: 'Loading...',
      editState: 'Loading...',
      editZipCode: 'Loading...',
      editEmail: 'Loading...',
      editPhone: 'Loading...',
      editUrl: 'Loading...'
    })
  }

  newOrganization(row) {
    this.props.organizations.newOrganization({
      organizationId: this.props.globals.loggedInUser.organizationId,
      name: row.name,
      address: row.address,
      city: row.city,
      state: row.state,
      email: row.email,
      zipCode: row.zipCode,
      phone: row.phone,
      url: row.url
    })
  }

  updateOrganization() {
      const data = {
        id: this.state.editId,
        name: this.state.editName,
        address: this.state.editAddress,
        city: this.state.editCity,
        state: this.state.editState,
        zipCode: this.state.editZipCode,
        email: this.state.editEmail,
        phone: this.state.editPhone,
        url: this.state.editUrl
      }

      this.props.organizations.updateOrganization(data)
      this.closeEditOrgModal()
  }

  deleteOrganization(id) {
    if (confirm('Are you sure you want to delete this Organization?')) {
      this.props.organizations.deleteOrganization(id)
    }
  }

  formatActions(cell, row) {
    return (
      <div>
        <Button bsSize="small" bsStyle="warning" id={ cell } onClick={ () => { this.openEditOrgModal(row) } }><i className="fa fa-pencil" aria-hidden="true"></i></Button>
        <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteOrganization(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
      </div>
    )
  }

//STATE CHANGE HANDLERS
  onEditNameChange(e) {
    this.setState({
      editName: e.target.value
    })
  }

  onEditAddressChange(e) {
    this.setState({
      editAddress: e.target.value
    })
  }

  onEditCityChange(e) {
    this.setState({
      editCity: e.target.value
    })
  }

  onEditStateChange(e) {
    this.setState({
      editState: e.target.value
    })
  }

  onEditZipCodeChange(e) {
    this.setState({
      editZipCode: e.target.value
    })
  }

  onEditEmailChange(e) {
    this.setState({
      editEmail: e.target.value
    })
  }

  onEditPhoneChange(e) {
    this.setState({
      editPhone: e.target.value
    })
  }

  onEditUrlChange(e) {
    this.setState({
      editUrl: e.target.value
    })
  }

  render() {

    const options = {
      onAddRow: this.newOrganization.bind(this)
    }

    const organizationsTable = (
        <BootstrapTable
        data={ this.props.organizations.data }
        striped={ true }
        hover={ true }
        pagination={ true }
        search={ true }
        exportCSV={ true }
        options={ options }
        insertRow={ true }
        bordered={ false }
        //cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updateOrganization.bind(this) } }
        insertRow >
          <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="address" dataSort={ true } editable={{ validator: Validators.validString }}>Address</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="city" dataSort={ true } editable={{ validator: Validators.validString }}>City</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="state" dataSort={ true } editable={{ validator: Validators.validString }}>State</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="zipCode" dataSort={ true } editable={{ validator: Validators.validString }}>Zip Code</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="email" dataSort={ true } editable={{ validator: Validators.validString }}>Email</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="phone" dataSort={ true } editable={{ validator: Validators.validString }}>Phone</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="url" dataSort={ true } editable={{ validator: Validators.validString }}>URL</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
        </BootstrapTable>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Organizations</Breadcrumb.Item>
            </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          <Collapsible title="Organizations" content={ organizationsTable } />
        </div>
        <div style={{ clear: 'both' }}></div>
        <Modal show={ this.state.showEditOrgModal } onHide={ this.closeEditOrgModal.bind(this) } bsSize="medium">
          <Modal.Header closeButton>
            <Modal.Title>Edit Organization</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Form horizontal name="editOrganizationForm">
            <input type="hidden" id="editAddressId" defaultValue={ this.state.editId }/>
              <FormGroup>
                <Col sm={ 12 }><FormControl type="text" placeholder="Organization Name" id="editName" value={ this.state.editName  } onChange={ this.onEditNameChange.bind(this) } /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={ 12 }><FormControl type="text" placeholder="Address" id="editAddress" value={ this.state.editAddress  } onChange={ this.onEditAddressChange.bind(this) } /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={ 4 }><FormControl type="text" placeholder="City" id="editCity" value={  this.state.editCity } onChange={ this.onEditCityChange.bind(this) } /></Col>
                <Col sm={ 4 }><StatesDropdown id="editState" defaultValue={ this.state.editState } onChange={ this.onEditStateChange.bind(this) } /></Col>
                <Col sm={ 4 }><FormControl type="text" placeholder="Zip Code" id="editZipCode" value={  this.state.editZipCode } onChange={ this.onEditZipCodeChange.bind(this) } /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={ 6 }><FormControl type="text" placeholder="Email" id="editEmail" value={ this.state.editEmail  } onChange={ this.onEditEmailChange.bind(this) } /></Col>
                <Col sm={ 6 }><FormControl type="text" placeholder="Phone" id="editPhone" value={ this.state.editPhone  } onChange={ this.onEditPhoneChange.bind(this) } /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={ 12 }><FormControl type="text" placeholder="http://" id="editUrl" value={  this.state.editUrl } onChange={ this.onEditUrlChange.bind(this) } /></Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.closeEditOrgModal.bind(this) }><i className="fa fa-times" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.updateOrganization.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/organizations.js